import React, { FC } from 'react';
import { FormControl, InputLabel, Select } from '@material-ui/core';

interface Props {
  value?: 0 | 1;
  className?: any;
  size?: 'small' | 'medium';
  onChange: (isGlobal?: 0 | 1) => void;
}

const TypeSelect: FC<Props> = ({ onChange, className, value, ...props }) => {
  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const value = parseInt(event.target.value as string);
    onChange(value === 0 ? 0 : 1);
  };

  return (
    <FormControl className={className} variant='outlined' {...props}>
      <InputLabel>Type</InputLabel>
      <Select native value={value} style={{ background: 'white' }} onChange={handleChange} label='Type'>
        <option value={0}>Clients</option>
        <option value={1}>Globaux</option>
      </Select>
    </FormControl>
  );
};

export default React.memo(TypeSelect);
